/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnableTwoFactorAuthRequest } from '../models/EnableTwoFactorAuthRequest';
import type { EnableTwoFactorAuthResponse } from '../models/EnableTwoFactorAuthResponse';
import type { GetMessageResponse } from '../models/GetMessageResponse';
import type { GetMessagesCountResponse } from '../models/GetMessagesCountResponse';
import type { GetMessagesListResponse } from '../models/GetMessagesListResponse';
import type { GetUserActivitiesListResponse } from '../models/GetUserActivitiesListResponse';
import type { GetUserProfileResponse } from '../models/GetUserProfileResponse';
import type { GetUserRolesListResponse } from '../models/GetUserRolesListResponse';
import type { UpdateUserProfileRequest } from '../models/UpdateUserProfileRequest';
import type { VerifyTwoFactorAuthRequest } from '../models/VerifyTwoFactorAuthRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * Verify 2FA
     * Verify Two-factor authentication endpoint for user.
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static verifyTwoFactorAuthEndpoint(
        requestBody: VerifyTwoFactorAuthRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/2fa/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Disable 2FA
     * Disable Two-factor authentication endpoint for user.
     * @returns any Success
     * @throws ApiError
     */
    public static disableTwoFactorAuthEndpoint(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/2fa/disable',
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * User roles list.
     * Retreives the list of user roles for the current user.
     * @returns GetUserRolesListResponse Success
     * @throws ApiError
     */
    public static getUserRolesListEndpoint(): CancelablePromise<GetUserRolesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/roles',
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Update user profile information.
     * Allows the current user to modify and save their profile details, including phone number, email, and system language preferences.
     * Changing the email address will trigger a confirmation process: the new email must be confirmed before the change is finalized.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateUserProfileEndpoint(
        requestBody: UpdateUserProfileRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The provided input is invalid or contains missing required fields.`,
                401: `The user is not authorized to perform this action.`,
                404: `The specified user profile could not be found.`,
            },
        });
    }
    /**
     * User profile.
     * Gets the profile information of the current user.
     * @returns GetUserProfileResponse Success
     * @throws ApiError
     */
    public static getUserProfileEndpoint(): CancelablePromise<GetUserProfileResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/profile',
            errors: {
                400: `Bad Request`,
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Marks all messages as read.
     * Marks all messages as read by user.
     * @returns any Success
     * @throws ApiError
     */
    public static messagesMarkReadAllEndpoint(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/messages/mark-read-all',
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Marks a message as read.
     * Marks a message as read by user.
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    public static messageMarkReadEndpoint(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/messages/{id}/mark-read',
            path: {
                'id': id,
            },
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * User messages list.
     * Gets the list of registered messages.
     * @param pageNumber
     * @param pageSize
     * @param legalEntityIds
     * @param senderTypeId
     * @param searchTerm
     * @param fromDate
     * @param toDate
     * @returns GetMessagesListResponse Success
     * @throws ApiError
     */
    public static getMessagesListEndpoint(
        pageNumber: number,
        pageSize: number,
        legalEntityIds?: Array<string> | null,
        senderTypeId?: string | null,
        searchTerm?: string | null,
        fromDate?: string | null,
        toDate?: string | null,
    ): CancelablePromise<GetMessagesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/messages',
            query: {
                'legalEntityIds': legalEntityIds,
                'senderTypeId': senderTypeId,
                'searchTerm': searchTerm,
                'fromDate': fromDate,
                'toDate': toDate,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized`,
            },
        });
    }
    /**
     * Permission.
     * Gets an instance of user permission.
     * @param id
     * @returns GetMessageResponse Success
     * @throws ApiError
     */
    public static getMessageEndpoint(
        id: string,
    ): CancelablePromise<GetMessageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/messages/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * User messages list.
     * Gets the list of registered messages.
     * @returns GetMessagesCountResponse Success
     * @throws ApiError
     */
    public static getMessagesCountEndpoint(): CancelablePromise<GetMessagesCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/messages/count',
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * User messages list.
     * Gets the list of registered messages.
     * @param pageNumber
     * @param pageSize
     * @param searchTerm
     * @param fromDate
     * @param toDate
     * @param traceId
     * @returns GetUserActivitiesListResponse Success
     * @throws ApiError
     */
    public static getUserActivitiesListEndpoint(
        pageNumber: number,
        pageSize: number,
        searchTerm?: string | null,
        fromDate?: string | null,
        toDate?: string | null,
        traceId?: string | null,
    ): CancelablePromise<GetUserActivitiesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/activities',
            query: {
                'searchTerm': searchTerm,
                'fromDate': fromDate,
                'toDate': toDate,
                'traceId': traceId,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Enable 2FA
     *
     * This endpoint enables Two-Factor Authentication (2FA) for a user.
     * By default, `Email` is used for verification.
     * The user can switch to `Authenticator`,
     * which requires an additional step to complete the setup by calling the verification endpoint.
     * Once verified, the 2FA setting is updated to true.
     *
     * @param requestBody
     * @returns EnableTwoFactorAuthResponse Success
     * @throws ApiError
     */
    public static enableTwoFactorAuthEndpoint(
        requestBody: EnableTwoFactorAuthRequest,
    ): CancelablePromise<EnableTwoFactorAuthResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/2fa/enable',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `User is not authorized to enable 2FA.`,
            },
        });
    }
}
